import { PersonaStorePage } from "@/components/personas/store/persona-store-page.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/settings/personas/store")(
	{
		component: PersonaStorePage,
		head: () => ({
			meta: [{ title: pageTitle(m.personas_store_title()) }],
		}),
	},
);
